export default function SectionApp() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl p-8 md:p-12 overflow-hidden relative">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-white blur-3xl"></div>
              <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-white blur-3xl"></div>
            </div>
            <div className="relative z-10 flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-4">
                随时随地，畅享精彩视频
              </h2>
              <p className="text-sm md:text-base text-white/80 leading-relaxed mb-6">
                69视频全面适配移动端浏览器，在手机上也能获得流畅舒适的观影浏览体验。
                将本站添加到手机桌面，一键直达，精彩内容触手可及。
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
                <span className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/15 text-white border border-white/25 text-sm font-medium cursor-default whitespace-nowrap">
                  <i className="ri-smartphone-line text-lg"></i>
                  手机浏览器访问
                </span>
                <span className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-primary-600 text-sm font-medium cursor-default whitespace-nowrap">
                  <i className="ri-bookmark-line text-lg"></i>
                  添加到桌面
                </span>
              </div>
            </div>
            <div className="relative z-10 flex-shrink-0">
              <div className="w-44 h-80 bg-white/10 rounded-3xl border-2 border-white/20 p-2 flex flex-col items-center justify-center gap-2">
                <div className="w-full h-28 rounded-2xl bg-white/15 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-3xl text-white/60"></i>
                </div>
                <div className="w-full h-2 rounded-full bg-white/15"></div>
                <div className="w-3/4 h-2 rounded-full bg-white/10"></div>
                <div className="w-full h-28 rounded-2xl bg-white/10 mt-2 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-2xl text-white/40"></i>
                </div>
                <div className="w-2/3 h-2 rounded-full bg-white/10"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}